import request from '../../../utils/request';
import {
  AzureCloudOption,
  AzureOnboardingListItem,
  AzureOnboardingRediscoverResult,
  AzureOnboardingVerifyResult,
  AzureScope,
  IAzureOnboardingConsentUrl,
  IAzureOnboardingCreated,
  IConnectClientManagedAzure,
  IConnectClientManagedAzureResult,
  ICreateAzureOnboarding,
} from './azureOnboarding.model';

class AzureOnboardingService {
  ENDPOINT = '/azure-onboarding';

  public async list(): Promise<AzureOnboardingListItem[]> {
    const res = await request({ url: this.ENDPOINT, method: 'GET' });
    return res.data.body.data;
  }

  public async create(data: ICreateAzureOnboarding): Promise<IAzureOnboardingCreated> {
    const res = await request({ url: this.ENDPOINT, method: 'POST', data });
    return res.data.body.data;
  }

  public async getConsentUrl(id: number): Promise<IAzureOnboardingConsentUrl> {
    const res = await request({ url: `${this.ENDPOINT}/${id}/consent-url`, method: 'GET' });
    return res.data.body.data;
  }

  public async verify(id: number): Promise<AzureOnboardingVerifyResult> {
    const res = await request({ url: `${this.ENDPOINT}/${id}/verify`, method: 'POST' });
    return res.data.body.data;
  }

  public async getScopes(id: number): Promise<AzureScope[]> {
    const res = await request({ url: `${this.ENDPOINT}/${id}/scopes`, method: 'GET' });
    return res.data.body.data;
  }

  public async setScopeActive(id: number, scopeId: number, active: boolean): Promise<void> {
    await request({
      url: `${this.ENDPOINT}/${id}/scopes/${scopeId}`,
      method: 'PATCH',
      data: { active },
    });
  }

  public async rediscover(id: number): Promise<AzureOnboardingRediscoverResult> {
    const res = await request({ url: `${this.ENDPOINT}/${id}/rediscover`, method: 'POST' });
    return res.data.body.data;
  }

  public async resetTenant(id: number): Promise<void> {
    await request({ url: `${this.ENDPOINT}/${id}/reset-tenant`, method: 'POST' });
  }

  public async listClouds(): Promise<AzureCloudOption[]> {
    const res = await request({ url: `${this.ENDPOINT}/clouds`, method: 'GET' });
    return res.data.body.data;
  }

  public async connectClientManaged(
    data: IConnectClientManagedAzure
  ): Promise<IConnectClientManagedAzureResult> {
    const res = await request({ url: `${this.ENDPOINT}/client-managed`, method: 'POST', data });
    return res.data.body.data;
  }
}

export default new AzureOnboardingService();
